<template>
  <span id="unit-actions-dropdown-section" v-show="displayActions">
    <el-dropdown id="manage-units-more-actions-dropdown" v-show="!outboundUnits.multiSelect" @command="handleCommand">
      <el-button class="manage-units-more-actions-button" type="success" plain size="mini">
        {{ $t('outbound.units.actions') }}<i class="el-icon-arrow-down el-icon--right" />
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-show="displayChangeShuttleLoad" id="change-shuttle-load-dropdown-item" command="changeShuttleLoad"><span class="more-actions-option">{{ $t('outbound.units.changeShuttleLoad') }}</span></el-dropdown-item>
        <el-dropdown-item v-show="displayReactivateAll" id="reactivate-all-dropdown-item" command="reactivateAll"><span class="more-actions-option">{{ $t('outbound.units.reactivateAll') }}</span></el-dropdown-item>
        <el-dropdown-item v-show="displayDeleteAll" id="delete-all-dropdown-item" command="deleteAll"><span class="more-actions-option">{{ $t('outbound.units.deleteAll') }}</span></el-dropdown-item>
        <el-dropdown-item v-show="displayClearPutAway" id="clear-put-away-dropdown-item" command="clearPutAway"><span class="more-actions-option">{{ $t('outbound.units.clearPutAway') }}</span></el-dropdown-item>
        <el-dropdown-item v-show="displayChangeShipDate" id="change-ship-date-dropdown-item" command="changeShipDate"><span class="more-actions-option">{{ $t('outbound.units.changeShipDate') }}</span></el-dropdown-item>
        <el-dropdown-item v-show="displayPrintLabels" id="print-labels-dropdown-item" command="printLabels"><span class="more-actions-option">{{ $t('outbound.units.printLabels') }}</span></el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <change-shuttle-load-dialog ref="changeShuttleLoad" />
    <reactivate-all ref="reactivateAll" />
    <delete-all ref="deleteAll" />
    <clear-put-away-button ref="clearPutAway" />
    <change-ship-date-dialog ref="changeShipDate" />
    <print-labels :validate-search="validateSearch" ref="printLabels" />
  </span>
</template>

<script>
import { mapGetters } from 'vuex';
import ChangeShuttleLoadDialog from '@/views/outbound/units/components/ChangeShuttleLoadDialog';
import ClearPutAwayButton from '@/views/outbound/units/components/ClearPutAwayButton';
import ChangeShipDateDialog from '@/views/outbound/units/components/ChangeShipDateDialog';
import DeleteAll from '@/views/outbound/units/components/DeleteAll';
import ReactivateAll from '@/views/outbound/units/components/ReactivateAll';
import PrintLabels from '@/views/outbound/units/components/PrintLabels';

export default {
  name: 'UnitActionsDropdown',
  components: {
    ChangeShuttleLoadDialog,
    ClearPutAwayButton,
    ChangeShipDateDialog,
    DeleteAll,
    ReactivateAll,
    PrintLabels
  },
  props: {
    validateSearch: Function
  },
  computed: {
    ...mapGetters(['outboundUnits']),
    displayChangeShuttleLoad() {
      return this.mounted && this.$refs.changeShuttleLoad.isVisible();
    },
    displayReactivateAll() {
      return this.mounted && this.$refs.reactivateAll.isVisible();
    },
    displayDeleteAll() {
      return this.mounted && this.$refs.deleteAll.isVisible();
    },
    displayClearPutAway() {
      return this.mounted && this.$refs.clearPutAway.isVisible();
    },
    displayChangeShipDate() {
      return this.mounted && this.$refs.changeShipDate.isVisible();
    },
    displayPrintLabels() {
      return this.mounted && this.$refs.printLabels.isVisible();
    },
    displayActions() {
      return this.displayChangeShuttleLoad || this.displayReactivateAll || this.displayDeleteAll
        || this.displayClearPutAway || this.displayChangeShipDate || this.displayPrintLabels;
    }
  },
  data() {
    return {
      mounted: false
    };
  },
  mounted() {
    this.mounted = true;
  },
  methods: {
    handleCommand(command) {
      switch (command) {
        case 'changeShuttleLoad':
          this.$refs.changeShuttleLoad.toggleMultiSelect();
          break;
        case 'reactivateAll':
          this.$refs.reactivateAll.handleReactivateAll();
          break;
        case 'deleteAll':
          this.$refs.deleteAll.handleDeleteAll();
          break;
        case 'clearPutAway':
          this.$refs.clearPutAway.handleClearPutAway();
          break;
        case 'changeShipDate':
          this.$refs.changeShipDate.handleOpen();
          break;
        case 'printLabels':
          this.$refs.printLabels.handlePrintAllLabels();
          break;
        default:
          this.$message.warning('Invalid action');
          break;
      }
    }
  }
};
</script>
